const LS_KEY = 'restaurantes_config_cocinas_v1';

/** Valores por defecto (misma semilla que la pantalla Configuración → Cocinas). */
export const DEFAULT_COCINAS_CONFIG = [
  { id: 1, nombre: 'Cocina caliente', codigo: 'CAL', orden: 1, activa: true },
  { id: 2, nombre: 'Cocina fría', codigo: 'FRI', orden: 2, activa: true },
  { id: 3, nombre: 'Postres / barra de bebidas', codigo: 'POST', orden: 3, activa: true },
];

export function getCocinasConfig() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length) return parsed;
    }
  } catch (_) {
    // ignore
  }
  return DEFAULT_COCINAS_CONFIG.map((r) => ({ ...r }));
}

export function setCocinasConfig(rows) {
  try {
    localStorage.setItem(LS_KEY, JSON.stringify(rows));
  } catch (_) {
    // ignore
  }
}

/** Cantidad de estaciones que pueden atender pedidos al mismo tiempo (cocinas activas). */
export function countCocinasActivas() {
  return getCocinasConfig().filter((r) => r.activa).length;
}
